<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.emailGroupManagement") }}</h4>
    </div>
    <div class="wrap_con type_bt_wrap">
      <div class="p-2" style="text-align: right">
        <button type="button" @click="addGroup" class="btn btn-primary btn-md m-2">
          {{ $t("common.add") }}
        </button>
      </div>
      <div>
        <table class="list_tbl">
          <thead>
            <tr>
              <th class="mobile_row">{{ $t("management.groupName") }}</th>
              <th class="mobile_h">{{ $t("management.useYN") }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="mailGroupList.length != 0">
            <tr v-for="(group, index) in mailGroupList" :key="index">
              <td :id="group.groupId">
                <router-link
                  :to="{ name: 'emailGroupUserMgmt', params: { groupId: group.groupId } }"
                  >{{ group.groupName }}</router-link
                >
              </td>
              <td>
                <router-link
                  :to="{ name: 'emailGroupUserMgmt', params: { groupId: group.groupId } }"
                  >{{ group.useYn }}</router-link
                >
              </td>
              <td>
                <button
                  type="button"
                  @click="deleteGroup(group, index)"
                  class="btn btn-secondary btn-sm"
                >
                  {{ $t("common.delete") }}
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--------------------------------------------   모달    ---------------------------------------------------------------->
    <CommonModal id="groupModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.roleRegister") }}</h3>
      </template>
      <template slot="body">
        <table class="write_tbl responsive_tbl">
          <tbody>
            <tr>
              <th>{{ $t("management.groupName") }}</th>
              <td>
                <input
                  type="text"
                  v-model="emailGroup.groupName"
                  name="groupName"
                  v-validate="'required'"
                  class="int_type01"
                />
              </td>
            </tr>
            <tr>
              <th>{{ $t("management.useYN") }}</th>
              <td>
                <select v-model="emailGroup.useYn">
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
      <template slot="footer">
        <button type="button" @click="saveNewGroup" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import { getEmailGroup, saveEmailGroup, deleteEmailGroup } from "@/api/mail";
import CommonModal from "@/components/modal/CommonModal";
export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      mailGroupList: [],
      emailGroup: { groupName: "", useYn: "Y" },
      confirmYN: false,
      showModal: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getEmailGroup("");
        this.mailGroupList = data.mailGroupList;
      } catch (error) {
        console.log(error);
      }
    },
    // group 삭제
    async deleteGroup(group, index) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteEmailGroup(group);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      }
      group, index;
    },
    //새로운 group 추가 modal
    addGroup() {
      this.showModal = true;
    },
    //전체저장
    saveGroup() {},
    //새로운 group 저장
    async saveNewGroup() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      try {
        this.emailGroup.crudType = "I";
        const { data } = await saveEmailGroup(this.emailGroup);
        if (data.message == null) {
          if (data.status) {
            this.showModal = false;
            alert(this.$t("alert.savedSuccessfully"));
            this.emailGroup = { groupName: "", useYn: "Y" };
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } else {
          alert(this.$t("alert.plzCheckAllValues"));
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style></style>
